import { Badge } from "@/components/ui/badge"
import { formatDate } from "@/lib/datasetRegistry"

// Feature #49 (Marketing Activity Plan Archive) — Milestone 4.
// Read-only stat strip rendered above "Riwayat Upload" on the Promo & Activity
// uploads page, via the typed `archivePanel` slot on <DatasetUploadsPage>. One
// card per recent mkt_activity_plan snapshot: sheet count, archived-cell count,
// and the "berubah sejak bulan lalu" diff badge (the oldest archived snapshot has
// no previous month, so its badge reads "Snapshot pertama"). No click-to-history
// interaction here — that is the future visualization feature. Purely
// presentational + SSR-safe (no window/document access).

export type ArchiveSnapshot = {
  id: number
  filename: string
  snapshot_label: string | null
  created_at: string
  sheet_count: number
  cell_count: number
  changed_count: number | null
}

function num(value: number): string {
  return value.toLocaleString("id-ID")
}

export function ActivityArchivePanel({ snapshots }: { snapshots: ArchiveSnapshot[] }) {
  if (snapshots.length === 0) return null

  return (
    <section className="mt-10">
      <div className="mb-4 flex items-center gap-2">
        <h2 className="mb-0">Arsip Marketing Plan Activity</h2>
        <Badge tone="muted">{snapshots.length} snapshot</Badge>
      </div>
      <p className="mb-4 text-ink-muted">
        Setiap upload <strong>Marketing Plan Activity</strong> diarsipkan lengkap (semua sheet, posisi
        sel, dan merge) sebagai versi bulanan yang tidak menimpa bulan sebelumnya.
      </p>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {snapshots.map((s) => (
          <div key={s.id} className="rounded-lg border border-hairline bg-surface p-4">
            <div className="flex items-baseline justify-between gap-2">
              <strong className="truncate" title={s.filename}>
                {s.snapshot_label || s.filename}
              </strong>
              <span className="shrink-0 text-ink-muted">{formatDate(s.created_at)}</span>
            </div>

            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-ink-body">
              <span>
                <strong>{num(s.sheet_count)}</strong> sheet
              </span>
              <span>
                <strong>{num(s.cell_count)}</strong> cell diarsipkan
              </span>
            </div>

            <div className="mt-3">
              {s.changed_count == null ? (
                <Badge tone="muted">Snapshot pertama</Badge>
              ) : (
                <Badge tone="accent">{num(s.changed_count)} cell berubah sejak bulan lalu</Badge>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
